import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

export const useGetFiles = (id: string, { enabled }: { enabled: boolean }) => {
  const trpc = useTRPC();
  return useQuery(
    trpc.files.getFiles.queryOptions(
      { id },
      {
        enabled,
        refetchInterval: (fileStatusData) =>
          Array.isArray(fileStatusData?.state?.data) &&
          fileStatusData?.state?.data?.some((file) => file.status === "pending")
            ? 5000
            : false,
      },
    ),
  );
};
